import { styled } from '@mui/material/styles';

import Img from '../../components/img/Img';

export const PageImageSection = styled('section')`
  position: relative;
  overflow: hidden;
  height: 520px;
`;

export const PageImg = styled(Img)`
  position: absolute;
  top: 0;
`;
